var _rect, _path;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

var SvgFacebook = function SvgFacebook(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 28,
    height: 28,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 0.75,
    y: 0.75,
    width: 26.5,
    height: 26.5,
    rx: 13.25,
    fill: "#5C7AFF",
    stroke: "#5C7AFF",
    strokeWidth: 1.5
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12.611 9.712v1.928h-1.41v2.356h1.41V21h2.901v-7.004h1.946s.184-1.13.272-2.366h-2.207v-1.61c0-.242.317-.566.63-.566h1.58V7h-2.15c-3.043 0-2.972 2.359-2.972 2.712Z",
    fill: "#fff"
  })));
};

export default SvgFacebook;